export enum PromocodesControlsEnum {
    PROMOCODE = 'promocode',
}
